/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClassAddRequest
 */
export interface ClassAddRequest {
    /**
     * Class details including name, description, and optional system prompts
     * @type {object}
     * @memberof ClassAddRequest
     */
    classDetails: object;
    /**
     * Email of the professor
     * @type {string}
     * @memberof ClassAddRequest
     */
    professorId: string;
}

/**
 * Check if a given object implements the ClassAddRequest interface.
 */
export function instanceOfClassAddRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "classDetails" in value;
    isInstance = isInstance && "professorId" in value;

    return isInstance;
}

export function ClassAddRequestFromJSON(json: any): ClassAddRequest {
    return ClassAddRequestFromJSONTyped(json, false);
}

export function ClassAddRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassAddRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'classDetails': json['classDetails'],
        'professorId': json['professorId'],
    };
}

export function ClassAddRequestToJSON(value?: ClassAddRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'classDetails': value.classDetails,
        'professorId': value.professorId,
    };
}

